import React, { Component } from 'react';
import _ from 'lodash';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
	WithStyles,
	createStyles,
	Grid,
	Radio,
	Card,
	RadioGroup,
	CardContent,
	Typography,
	Chip,
	FormControlLabel,
} from '@material-ui/core';
import {
	CloseOutlined as CloseIcon,
} from '@material-ui/icons';
import { UserBody } from '../types/UsersBody';
import { UserRoleBody } from '../types/UserRolesBody';
import { MiniLibraryBody } from '../types/MiniLibraryBody';

import { miniLibraryList } from '../actions/miniLibrariesActions';
import { assignRole } from '../actions/usersActions'
import { MyPATDialog, MyPATIconButton, SearchField } from '../../common';
import { usersList } from '../actions/usersActions';
import { userGroupsList } from '../actions/userGroupsActions';
import { getUserCount } from '../actions/usersActions';

import CreateRoleDialog from './CreateRoleDialog';
import AddMiniLibraryDialog from './AddMiniLibraryDialog';


const styles = (theme: Theme) => createStyles({
	mb1x: {
		marginBottom: theme.spacing.unit,
	},
	mb2x: {
		marginBottom: theme.spacing.unit * 2,
	},
	cardRoot: {
		overflow: "visible",
		marginBottom: theme.spacing.unit,
	},
	cardContentRoot: {
		...theme.mixins.gutters(),
		paddingTop: theme.spacing.unit * 2,
		paddingBottom: theme.spacing.unit * 2,
		'&:last-child': {
			paddingBottom: theme.spacing.unit * 2,
		},
	},
	dialogCloseContainer: {
		textAlign: 'right',
	},
	suggestContainer: {
		position: 'relative',
	},
	suggestList: {
		position: 'absolute',
		width: '100%',
		height: 'auto',
		top: '34px',
		left: '0',
		padding: 0,
		marginTop: 0,
		zIndex: 1,
		listStyleType: 'none',
		backgroundColor: theme.palette.common.white,
		boxShadow: theme.shadows[1],
		borderRadius: `0 0 ${theme.shape.borderRadius}px ${theme.shape.borderRadius}px`,
		'& li': {
			...theme.typography.body2,
			fontWeight: theme.typography.fontWeightRegular,
			display: 'block',
			cursor: 'pointer',
			padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
			'&.selected': {
				backgroundColor: theme.palette.grey[200],
			}
		}
	},
	searchUserGroupRoot: {
		border: `1px solid ${theme.palette.grey[300]}`,
		borderRadius: theme.shape.borderRadius,
		padding: `0 ${theme.spacing.unit}px`,
	},
	chipWrap: {
		padding: `0 ${theme.spacing.unit}px`,
		'& > div': {
			marginRight: theme.spacing.unit / 2,
			marginBottom: theme.spacing.unit / 2,
			'& > span': {
				fontSize: "0.7rem"
			}
		}
	},
	selectRoleRoot: {
		marginLeft: `-${theme.spacing.unit / 2}px`,
		marginRight: theme.spacing.unit * 3,
		height:'45px',
		width:'17%',
	},
	selectRoleRadioRoot: {
		padding: theme.spacing.unit / 2,
	},
	selectRoleRadioLabel: {
		textTransform: 'capitalize',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
	radioGroupRoot: {
		alignItems: 'center',
	},
	newRole: {
		fontWeight: theme.typography.fontWeightRegular,
		color: theme.palette.primary.main,
		cursor: "pointer"
	}
});

interface AssignRoleDialogProps extends WithStyles<typeof styles> {
	dialogOpen: boolean,
	users: UserBody[],
	userRoles: UserRoleBody[],
	dialogCloseHandler: Function,
	assignRoleUserId: string,
	miniLibrary: MiniLibraryBody[],
	miniLibraryList: () => void,
	usersList: Function,
	getUserCount: () => void,
	userGroupsList: () => void,


}

interface AssignRoleDialogState {
	suggestedReviewers: any,
	showSuggestedReviewerGroup: boolean,
	selectedReviewers: any[],
	formData: any,
	suggestedUsers: any,
	showSuggestedUsers: boolean,
	selectedUsers: any[],
	createRoledialogOpen: boolean,
	createMiniLdialogOpen: boolean

}

class AssignRoleDialog extends Component<AssignRoleDialogProps, AssignRoleDialogState> {
	constructor(props: AssignRoleDialogProps) {
		super(props);
		this.state = {
			suggestedReviewers: [],
			showSuggestedReviewerGroup: false,
			selectedReviewers: [],
			formData: {},
			suggestedUsers: [],
			showSuggestedUsers: false,
			selectedUsers: [],
			createRoledialogOpen: false,
			createMiniLdialogOpen: false,
		};

		this.handleDialogSave = this.handleDialogSave.bind(this);
		this.searchReviewerGroupSuggestion = this.searchReviewerGroupSuggestion.bind(this);
		this.searchUserSuggestion = this.searchUserSuggestion.bind(this);
		this.handleChangeEvent = this.handleChangeEvent.bind(this);
	}

	componentDidMount() {
	}

	componentWillReceiveProps() {
		setTimeout(this.initilizeUser.bind(this), 700);
	}

	initilizeUser() {
		let { users, assignRoleUserId, userRoles, miniLibrary } = this.props;
		let { selectedUsers, formData } = this.state;
		if (users && users.length > 0 && assignRoleUserId) {
			let userDetail = _.find(users, ['_id', assignRoleUserId]);
			if (userDetail) {
				selectedUsers = [];
				selectedUsers.push(userDetail);
				formData["roleId"] = userRoles && userRoles.length > 0 && userRoles[0]._id;
				formData["miniLibrary"] = miniLibrary && miniLibrary.length > 0 && miniLibrary[0]._id;
				this.setState({ selectedUsers, formData });
			}
		}
	}

	searchReviewerGroupSuggestion(e: any) {
		let { users, miniLibrary } = this.props;
		let { suggestedReviewers, formData } = this.state;
		let { name, value } = e.target;
		let selectedMiniLibraryId = formData.miniLibrary ? formData.miniLibrary : miniLibrary && miniLibrary.length > 0 ? miniLibrary[0]._id : "";
		suggestedReviewers = [];
		users.forEach((user: any) => {
			if (value && user && user.fullName && user.fullName.toLowerCase().search(value.toLowerCase()) != -1) {
				let isMiniLibraryPresent = user.roles ? user.roles.find((u: any) => (u.miniLibrary && u.miniLibrary._id == selectedMiniLibraryId)) : "";
				if (isMiniLibraryPresent && suggestedReviewers.length < 5) {
					suggestedReviewers.push(user);
				} else {
					return false;
				}
			}
		});


		this.setState({ suggestedReviewers });
	}

	chooseReviewerGroup(user: any, isAdd: boolean) {
		let { selectedReviewers } = this.state;
		if (isAdd) {
			let isUserPresnt = _.find(selectedReviewers, ['_id', user._id]);
			if (!isUserPresnt)
				selectedReviewers.push(user);
		}
		else
			selectedReviewers = selectedReviewers.filter((ob: any) => ob._id != user._id);
		this.setState({ selectedReviewers })
	}


	searchUserSuggestion(e: any) {
		let { users } = this.props;
		let { suggestedUsers } = this.state;
		let { name, value } = e.target;
		suggestedUsers = [];
		users.forEach((user: any) => {
			if (value && user && user.fullName && user.fullName.toLowerCase().search(value.toLowerCase()) != -1) {
				if (suggestedUsers.length < 5) {
					suggestedUsers.push(user);
				} else {
					return false;
				}
			}
		});
		this.setState({ suggestedUsers });
	}

	chooseUser(user: any, isAdd: boolean) {
		let { selectedUsers } = this.state;
		if (isAdd) {
			let isUserPresnt = _.find(selectedUsers, ['_id', user._id]);
			if (!isUserPresnt)
				selectedUsers.push(user);
		}
		else
			selectedUsers = selectedUsers.filter((ob: any) => ob._id != user._id);
		this.setState({ selectedUsers })
	}

	handleDialogSave = () => {
		let { formData, selectedReviewers, selectedUsers } = this.state;
		let reqBody: any = {};
		if (selectedUsers && selectedUsers.length > 0 && formData.roleId && formData.miniLibrary) {
			reqBody["_id"] = selectedUsers.map(s => s._id);
			reqBody["roles"] = { "roleId": formData.roleId, "miniLibrary": formData.miniLibrary };
			reqBody["reviewer"] = selectedReviewers.map(s => s._id);
			assignRole(reqBody)
				.then((res: any) => {
					if (res) {
						this.setState({
							formData: {},
							suggestedReviewers: [],
							selectedReviewers: [],
							suggestedUsers: [],
							selectedUsers: [],
						});
						this.props.usersList();
						this.props.userGroupsList();
						this.props.getUserCount();
						this.props.dialogCloseHandler();

					}
				})
		}

	}

	handleChangeEvent(e: any) {
		let { name, value } = e.target;
		let { formData, suggestedReviewers, selectedReviewers } = this.state;
		formData[name] = value;

		if (name == 'miniLibrary') {
			suggestedReviewers = [];
			selectedReviewers = [];
		}

		this.setState({ formData, selectedReviewers, suggestedReviewers });
	}


	createNewRole(isShow: boolean, e: any) {
		this.setState({ createRoledialogOpen: isShow });
	}

	createNewMiniLibrary(isShow: boolean, e: any) {
		this.setState({ createMiniLdialogOpen: isShow });
	}

	render() {
		const {
			classes,
			userRoles,
			miniLibrary,
			dialogOpen,
			dialogCloseHandler,
			assignRoleUserId,
		} = this.props;

		const {
			suggestedReviewers,
			showSuggestedReviewerGroup,
			selectedReviewers,
			formData,
			suggestedUsers,
			showSuggestedUsers,
			createRoledialogOpen,
			createMiniLdialogOpen,
			selectedUsers,
		} = this.state;

		const otherDialogProps = {
			fullWidth: true,
			maxWidth: 'md',
			scroll: 'body',
		};

		const getReviewerGroup = () => (
			_.map(selectedReviewers, (gr, i) => (
				<Chip
					key={`${gr._id}-${i}`}
					label={gr.fullName}
					onDelete={this.chooseReviewerGroup.bind(this, gr, false)}
				/>
			))
		)

		const getUser = () => (
			_.map(selectedUsers, (gr, i) => (
				_.isEqual(i, 0)
					?
					<Chip
						key={`${gr._id}-${i}`}
						label={gr.fullName}
					/>
					:
					<Chip
						key={`${gr._id}-${i}`}
						label={gr.fullName}
						onDelete={this.chooseUser.bind(this, gr, false)}
					/>
			))
		)

		return (
			<>

				<MyPATDialog
					dialogOpen={dialogOpen}
					otherDialogProps={otherDialogProps}
					onDialogSave={this.handleDialogSave.bind(this)}
					customDialogTitle={
						<Grid container justify="space-between" alignItems="center">
							<Grid item xs>
								<Typography variant="h6"> Assign User Roles </Typography>
							</Grid>

							<Grid item xs="auto" className={classes.dialogCloseContainer}>
								<MyPATIconButton buttonVariant="flat" onClick={dialogCloseHandler}>
									<CloseIcon />
								</MyPATIconButton>
							</Grid>
						</Grid>
					}
				>
					<Card className={classes.cardRoot}>
						<CardContent className={classes.cardContentRoot}>
							<Grid container alignItems="center">

								<Grid item xs={12} className={classes.mb2x}>
									<Typography variant="body1" gutterBottom>
										<strong>Name</strong>
									</Typography>
									<div className={classes.chipWrap}>
										{getUser()}
									</div>
									<div className={classes.suggestContainer}>
										<SearchField
											name="reviewerGroup"
											id="reviewerGroup"
											placeholder="Search Users"
											className={classes.searchUserGroupRoot}
											onFocus={() => { this.setState({ showSuggestedUsers: true }) }}
											onBlur={() => { setTimeout(() => { this.setState({ showSuggestedUsers: false }) }, 500) }}
											onChange={this.searchUserSuggestion}
											fullWidth
										/>
										{showSuggestedUsers && suggestedUsers.length > 0 && (
											<ul className={classes.suggestList}>
												{_.map(suggestedUsers, (sc, i: number) => (
													<li key={i}
														className={_.find(selectedUsers, ['_id', sc._id]) ? 'selected' : ''}
														onClick={this.chooseUser.bind(this, sc, true)}
													>
														{sc.fullName}
													</li>
												))}
											</ul>
										)}
									</div>
								</Grid>

								<Grid item xs={12} className={classes.mb2x}>
									<Typography variant="body1" gutterBottom>
										<strong>Select Role</strong>
									</Typography>
									<RadioGroup
										row
										id="roleId"
										name="roleId"
										value={!_.isUndefined(formData.roleId) ? formData.roleId : ""}
										defaultValue={userRoles && userRoles.length > 0 ? userRoles[0]._id : ""}
										classes={{ root: classes.radioGroupRoot }}
									>
										{_.map(userRoles, (role, i) => (
											<FormControlLabel
												control={<Radio color="primary" classes={{ root: classes.selectRoleRadioRoot }} />}
												label={role.role}
												key={`${role._id}-${i}`}
												onChange={this.handleChangeEvent}
												value={!_.isEmpty(role._id) ? role._id : ""}
												classes={{
													root: classes.selectRoleRoot,
													label: classes.selectRoleRadioLabel
												}}
											/>
										))}
										<Typography inline variant="body2"
											className={classes.newRole}
											onClick={this.createNewRole.bind(this, true)}
										>
											Add New Role
										</Typography>
									</RadioGroup>

								</Grid>

								<Grid item xs={12} className={classes.mb2x}>
									<Typography variant="body1" gutterBottom>
										<strong>Select Reviewer</strong>
									</Typography>
									<div className={classes.chipWrap}>
										{getReviewerGroup()}
									</div>
									<div className={classes.suggestContainer}>
										<SearchField
											name="reviewerGroup"
											id="reviewerGroup"
											placeholder="Search Users"
											className={classes.searchUserGroupRoot}
											onFocus={() => { this.setState({ showSuggestedReviewerGroup: true }) }}
											onBlur={() => { setTimeout(() => { this.setState({ showSuggestedReviewerGroup: false }) }, 500) }}
											onChange={this.searchReviewerGroupSuggestion}
											fullWidth
										/>
										{showSuggestedReviewerGroup && suggestedReviewers.length > 0 && (
											<ul className={classes.suggestList}>
												{_.map(suggestedReviewers, (sc, i: number) =>
													!_.isEqual(assignRoleUserId, sc._id) && (
														<li key={i}
															className={_.find(selectedReviewers, ['_id', sc._id]) ? 'selected' : ''}
															onClick={this.chooseReviewerGroup.bind(this, sc, true)}
														>
															{sc.fullName}
														</li>
													))}
											</ul>
										)}
									</div>
								</Grid>

								<Grid item xs={12} className={classes.mb2x}>
									<Typography variant="body1" gutterBottom>
										<strong>Select Mini Library for this Role</strong>
									</Typography>
									<RadioGroup
										row
										id="miniLibrary"
										name="miniLibrary"
										value={!_.isUndefined(formData.miniLibrary) ? formData.miniLibrary : ""}
										defaultValue={miniLibrary && miniLibrary.length > 0 ? miniLibrary[0]._id : ""}
										classes={{ root: classes.radioGroupRoot }}
									>
										{_.map(miniLibrary, (m, i) => (
											<FormControlLabel
												control={<Radio color="primary" classes={{ root: classes.selectRoleRadioRoot }} />}
												label={m.name}
												key={`${m._id}-${i}`}
												onChange={this.handleChangeEvent}
												value={!_.isEmpty(m._id) ? m._id : ""}
												classes={{
													root: classes.selectRoleRoot,
													label: classes.selectRoleRadioLabel
												}}
											/>
										))}
										<Typography inline variant="body2"
											className={classes.newRole}
											onClick={this.createNewMiniLibrary.bind(this, true)}
										>
											Add New Mini Library
										</Typography>
									</RadioGroup>
								</Grid>
							</Grid>
						</CardContent>
					</Card>
				</MyPATDialog>

				<CreateRoleDialog
					dialogOpen={createRoledialogOpen}
					dialogCloseHandler={this.createNewRole.bind(this, false)}
				/>

				<AddMiniLibraryDialog
					dialogOpen={createMiniLdialogOpen}
					dialogCloseHandler={this.createNewMiniLibrary.bind(this, false)}
				/>
			</>
		);
	}
}

const mapStateToProps = (state: any) => ({
	users: _.get(state, 'userManagement.users.list', []),
	userRoles: _.get(state, 'userManagement.userRoleList.list', []),
	miniLibrary: _.get(state, 'userManagement.miniLibrary.list', []),
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
	miniLibraryList,
	usersList,
	getUserCount,
	userGroupsList,
}, dispatch);


// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AssignRoleDialog));